// import React, { useEffect } from 'react';
// import Navbar from 'react-bootstrap/Navbar';
// import { useState } from 'react';
// // تأكد من إضافة هذه الاستيرادات في أعلى الملف مع بقية الاستيرادات
// import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
// import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
// import ListAltIcon from '@mui/icons-material/ListAlt';
// import { Avatar, Fab, IconButton, Input, Tooltip, Typography } from '@mui/material';
// import logo from '../images/Realatix_Black.png';
// import logodark from '../images/Realatix_Black.png';

// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import AssignmentIcon from '@mui/icons-material/Assignment';
// import LogoutIcon from '@mui/icons-material/Logout';

// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';

// import List from '@mui/material/List';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemText from '@mui/material/ListItemText';
// import MenuItem from '@mui/material/MenuItem';
// import Menu from '@mui/material/Menu';

// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

// import SearchIcon from '@mui/icons-material/Search';
// import CancelIcon from '@mui/icons-material/Cancel';
// import { useDispatch, useSelector } from 'react-redux';
// import { GetAllLeadsSearchAction } from '../Redux/Actions/UsersAction';

// import axios from 'axios';
// // import { LeftSlider } from '../Utility/LeftSlider';
// import Form from 'react-bootstrap/Form';
// import InputGroup from 'react-bootstrap/InputGroup';
// import {
//   isMobile,
//   isTablet,
//   isDesktop,
//   browserName,
//   engineName,
//   osName,
// } from 'react-device-detect';
// import { Add_User_Activation_Logout_Action } from '../Redux/Actions/User_Activation_Action';
// import ManageSearchIcon from '@mui/icons-material/ManageSearch';

// // import LogoutIcon from '@mui/icons-material/Logout';

// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';

// import { TextField, Box } from '@mui/material';
// import { CountrySelect } from 'react-country-state-city';
// import 'react-country-state-city/dist/react-country-state-city.css';
// import dayjs from 'dayjs';
// import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';

// import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
// import { Getalldatauserlog_forsearch } from '../Redux/Actions/AuthAction';
// import { useLocation } from 'react-router-dom';
// import { Leftsidebare2 } from '../Utility/Leftsidebare2';

// import ListItemIcon from '@mui/material/ListItemIcon';
// import Divider from '@mui/material/Divider';
// import PersonAdd from '@mui/icons-material/PersonAdd';
// import { Container } from 'react-bootstrap';
// import NotificationBell from '../Pages/NotificationBell';
// import { Leftsidebare3 } from '../Utility/Leftsidebare3';
// import { db_url } from '../Api/BaseUrl';
// import { Logoutsession_one_Device } from '../Redux/Actions/Devices_Action';
// // import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';
// // import { Notify } from '../Utility/Notify';

// const ariaLabel = { 'aria-label': 'description' };

// export const Navbarheader = ({ setmode, mode }) => {
//   // const URL=`${db_url}/UsersImages/`;
//   const [anchorElmenue, setAnchorElmenue] = React.useState(null);
//   const openmenue = Boolean(anchorElmenue);
//   const handleClickmenue = (event) => {
//     setAnchorElmenue(event.currentTarget);
//   };
//   const handleClosemenue = () => {
//     setAnchorElmenue(null);
//   };

//   const limit = 10000;

//   const [selectedSale, setSelectedSale] = useState(null);

//   //sales filter input
//   const filterOptions = createFilterOptions({
//     matchFrom: 'start',
//     stringify: (option) => option.name,
//   });

//   const handleChange = (event, newValue) => {
//     // هنا يتم تحديد القيمة التي تم اختيارها
//     setSelectedSale(newValue); // `newValue` هي القيمة المختارة
//   };

//   // ///////////////////////////////////////////////////

//   const [value, setValue] = useState(null);
//   const [datefrom, setdatefrom] = useState(null);
//   const [dateto, setdateto] = useState(null);
//   const [datefromwithsales, setdatefromwithsales] = useState(null);
//   const [datetowithsales, setdatetowithsales] = useState(null);
//   const [selecteduser, setselecteduser] = useState('');
//   const [lastcommentdate, setlastcommentdate] = useState('');
//   const [country, setCountry] = useState(null);
//   //left slider show when press on div "|||"
//   const [user, setuser] = useState('');
//   const [isMobile, setIsMobile] = useState(false);
//   // const [showOffcanvas, setShowOffcanvas] = useState(false); // لحالة عرض الـ Offcanvas في الشاشات الصغيرة
//   const [openDrawer, setOpenDrawer] = useState(false); // حالة فتح الـ Drawer
//   const [anchorEl, setAnchorEl] = React.useState(null);
//   const [selectedIndex, setSelectedIndex] = React.useState(0);
//   // change search
//   // -========================================================
//   // const [search,setsearch]=useState('')
//   const [searchtype, setsearchtype] = useState('');
//   const [userInfo, setUserInfo] = useState(null);
//   // search sales and country and creation date
//   const [secondsearch, setsecondsearch] = useState(false);
//   const [location, setLocation] = useState(null);
//   const [showsearch, setShowsearch] = useState(false);

//   const [userlogin, setuserlogin] = useState('');
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   // searchsalesinput

//   // ========================================================
//   // search with tesmlesder

//   const [searchsales, setSearchsales] = useState(localStorage.getItem('searchsalesstorage') || '');
//   // const [selectedStage, setSelectedStage] = useState(null);

//   // const [filteredLeads, setFilteredLeads] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // استبدل مصفوفة stages الثابتة بالحالة التالية
//   // const [stages, setStages] = useState([]);

//   // // احصل على البيانات من الـ Redux store
//   // const resallstages = useSelector(state => state.Allstages.stage);

//   // // عند تحميل المكون أو تغير البيانات، حدّث مصفوفة stages
//   // useEffect(() => {
//   //   if (resallstages && resallstages.data) {
//   //     // استخراج أسماء المراحل فقط
//   //     const stageNames = resallstages.data.map(stage => stage.name);
//   //     setStages(stageNames);

//   //     // أو إذا كنت تريد استخدام كائنات كاملة:
//   //     // setStages(resallstages.data);
//   //   }
//   // }, [resallstages]);

//   // // دالة جلب البيانات
//   // const getallstages = async () => {
//   //   await dispatch(GetAll_stage_Data());
//   // };

//   // useEffect(() => {
//   //   getallstages();
//   // }, []);

//   // console.log(resallstages,"resallstages resallstages")

//   const searchsaleschange = (e) => {
//     const value = e.target.value || ''; // إضافة تحقق
//     setSearchsales(value);
//     localStorage.setItem('searchsalesstorage', value);
//     window.dispatchEvent(new Event('searchsalesUpdated'));
//   };

//   // تحديث `localStorage` عند تغيير البحث
//   useEffect(() => {
//     localStorage.setItem('searchsalesstorage', searchsales);
//   }, [searchsales]);

//   // =======================================================================
//   const [searchMarketeruser, setsearchMarketeruser] = useState(
//     localStorage.getItem('searchMarketerstorage') || '',
//   );

//   const searchMarketerchange = (e) => {
//     const value = e.target.value;
//     setsearchMarketeruser(value);
//     localStorage.setItem('searchMarketerstorage', value);

//     // 🔥 أطلق Event جديد لتحديث البحث في الصفحات الأخرى بدون Refresh
//     window.dispatchEvent(new Event('searchMarketerUpdated'));
//   };

//   // تحديث `localStorage` عند تغيير البحث
//   useEffect(() => {
//     localStorage.setItem('searchMarketerstorage', searchMarketeruser);
//   }, [searchMarketeruser]);

//   // ==================================================================
//   // search with sales
//   const [searchsalesuser, setSearchsalesuser] = useState(
//     localStorage.getItem('searchsalesuserstorage') || '',
//   );

//   const searchwithsaleschange = (e) => {
//     const value = e.target.value;
//     setSearchsalesuser(value);
//     localStorage.setItem('searchsalesuserstorage', value); // لا تضيف s هنا

//     // 🔥 أطلق Event جديد لتحديث البحث في الصفحات الأخرى بدون Refresh
//     window.dispatchEvent(new Event('searchsalesuserstorageUpdate'));
//   };

//   // تحديث `localStorage` عند تغيير البحث
//   useEffect(() => {
//     localStorage.setItem('searchsalesuserstorage', searchsalesuser);
//   }, [searchsalesuser]);

//   // ===============================================================

//   // search with Accountant user
//   const [searchAccountantuser, setsearchAccountantuser] = useState(
//     localStorage.getItem('searchAccountantuserstorage') || '',
//   );

//   const searchwithAccountantchange = (e) => {
//     const value = e.target.value;
//     setsearchAccountantuser(value);
//     localStorage.setItem('searchAccountantuserstorage', value);

//     // 🔥 أطلق Event جديد لتحديث البحث في الصفحات الأخرى بدون Refresh
//     window.dispatchEvent(new Event('searchAccountantuserstorageUpdate'));
//   };

//   // تحديث `localStorage` عند تغيير البحث
//   useEffect(() => {
//     localStorage.setItem('searchAccountantuserstorage', searchAccountantuser);
//   }, [searchAccountantuser]);

//   // ==========================================search Admin
//   const [search, setsearch] = useState(localStorage.getItem('mainsearchstorage') || '');

//   const mainsearchchange = (e) => {
//     const value = e.target.value || '';
//     setsearch(value);
//     localStorage.setItem('mainsearchstorage', value);

//     // 🔥 أطلق Event جديد لتحديث البحث في الصفحات الأخرى بدون Refresh
//     window.dispatchEvent(new Event('mainsearchupdated'));
//   };

//   // تحديث `localStorage` عند تغيير البحث
//   useEffect(() => {
//     localStorage.setItem('mainsearchstorage', search);
//   }, [search]);

//   // ===========================================

//   // ===========================================================================
//   // search with manager
//   const [searchsaleswithmanager, setSearchsaleswithmanager] = useState(
//     localStorage.getItem('searchsalesstoragewithmanager') || '',
//   );

//   const searchsalesmanagerchange = (e) => {
//     const value = e.target.value;
//     setSearchsaleswithmanager(value);
//     localStorage.setItem('searchsalesstoragewithmanager', value);

//     // 🔥 أطلق Event جديد لتحديث البحث في الصفحات الأخرى بدون Refresh
//     window.dispatchEvent(new Event('searchsalesmanagerUpdated'));
//   };

//   // تحديث `localStorage` عند تغيير البحث
//   useEffect(() => {
//     localStorage.setItem('searchsalesstoragewithmanager', searchsaleswithmanager);
//   }, [searchsaleswithmanager]);

//   // ===========================================================================

//   const handleDatetoChange = (newValue) => {
//     if (newValue) {
//       // التنسيق ليظهر التاريخ فقط بدون الوقت
//       const formattedDate = newValue.format('YYYY-MM-DD');
//       setdateto(formattedDate); // تخزين التاريخ بالتنسيق المناسب
//     } else {
//       setdateto(null); // إذا كانت القيمة فارغة
//     }
//   };

//   const [datetostage, setdatetostage] = useState(null);
//   const handleDatetoChangestage = (newValue) => {
//     if (newValue) {
//       // التنسيق ليظهر التاريخ فقط بدون الوقت
//       const formattedDate = newValue.format('YYYY-MM-DD');
//       setdatetostage(formattedDate); // تخزين التاريخ بالتنسيق المناسب
//     } else {
//       setdatetostage(null); // إذا كانت القيمة فارغة
//     }
//   };

//   const handleDatefromChange = (newValue) => {
//     if (newValue) {
//       // التنسيق ليظهر التاريخ فقط بدون الوقت
//       const formattedDate = newValue.format('YYYY-MM-DD');
//       setdatefrom(formattedDate); // تخزين التاريخ بالتنسيق المناسب
//     } else {
//       setdatefrom(null); // إذا كانت القيمة فارغة
//     }
//   };

//   const [datefromstage, setdatefromstage] = useState(null);

//   const handleDatefromChangestage = (newValue) => {
//     if (newValue) {
//       // التنسيق ليظهر التاريخ فقط بدون الوقت
//       const formattedDate = newValue.format('YYYY-MM-DD');
//       setdatefromstage(formattedDate); // تخزين التاريخ بالتنسيق المناسب
//     } else {
//       setdatefromstage(null); // إذا كانت القيمة فارغة
//     }
//   };

//   // ==========================================================================
//   const handleDatefromwithsalesChange = (newValue) => {
//     if (newValue) {
//       // التنسيق ليظهر التاريخ فقط بدون الوقت
//       const formattedDate = newValue.format('YYYY-MM-DD');
//       setdatefromwithsales(formattedDate); // تخزين التاريخ بالتنسيق المناسب
//     } else {
//       setdatefromwithsales(null); // إذا كانت القيمة فارغة
//     }
//   };

//   const handleDatetowithsalesChange = (newValue) => {
//     if (newValue) {
//       // التنسيق ليظهر التاريخ فقط بدون الوقت
//       const formattedDate = newValue.format('YYYY-MM-DD');
//       setdatetowithsales(formattedDate); // تخزين التاريخ بالتنسيق المناسب
//     } else {
//       setdatetowithsales(null); // إذا كانت القيمة فارغة
//     }
//   };

//   // ===========================================================================
//   const handleDateChangelastcomment = (newValue) => {
//     if (newValue) {
//       // التنسيق ليظهر التاريخ فقط بدون الوقت
//       const formattedDate = newValue.format('YYYY-MM-DD');
//       setlastcommentdate(formattedDate); // تخزين التاريخ بالتنسيق المناسب
//     } else {
//       setlastcommentdate(null); // إذا كانت القيمة فارغة
//     }
//   };

//   // ===========================================================================
//   const handleDateChange = (newValue) => {
//     if (newValue) {
//       // التنسيق ليظهر التاريخ فقط بدون الوقت
//       const formattedDate = newValue.format('YYYY-MM-DD');
//       setValue(formattedDate); // تخزين التاريخ بالتنسيق المناسب
//     } else {
//       setValue(null); // إذا كانت القيمة فارغة
//     }
//   };

//   // ==========================================================================

//   const handleClosesecondsearch = () => setsecondsearch(false);
//   const handleShowsecondsearch = () => setsecondsearch(true);

//   // تحديث حالة الشاشة (صغيرة أو كبيرة)
//   useEffect(() => {
//     const checkSize = () => {
//       if (window.innerWidth < 600) {
//         setIsMobile(true); // شاشة صغيرة
//         setOpenDrawer(false); // إغلاق الـ Offcanvas في الشاشات الصغيرة
//       } else {
//         setIsMobile(false); // شاشة كبيرة
//         setOpenDrawer(true); // فتح الـ Offcanvas في الشاشات الكبيرة
//       }
//     };

//     // تنفيذ الدالة عند تحميل الصفحة أو عند تغيير حجم الشاشة
//     checkSize();
//     window.addEventListener('resize', checkSize);

//     // تنظيف عند تغيير الحجم أو مغادرة الصفحة
//     return () => {
//       window.removeEventListener('resize', checkSize);
//     };
//   }, []);

//   const toggleOffcanvas = () => {
//     // setShowOffcanvas(!showOffcanvas);
//     setOpenDrawer(!openDrawer); // تغير حالة الـ Drawer عند الضغط على الزر
//   };

//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuser(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const handleClosesearch = () => {
//     setShowsearch(false);
//   };
//   const handleShow = () => {
//     setShowsearch(true);
//   };

//   // dropdown filteration

//   const options = [
//     'Sales',
//     'Country',
//     'Creation Date',
//     'All Lead Between Diffrent Dates',
//     'All Leads With Sales Between Different 2 Date',
//     'All Leads By User',
//     'All Leads With Last Comment Date',
//   ];

//   const open = Boolean(anchorEl);
//   const handleClickListItem = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleMenuItemClick = (event, index) => {
//     setSelectedIndex(index);
//     setAnchorEl(null);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   //sales filter input
//   const filterOptionsselecteduser = createFilterOptions({
//     matchFrom: 'start',
//     stringify: (option) => option.name,
//   });

//   const handleChangeselecteduser = (event, newValue) => {
//     // هنا يتم تحديد القيمة التي تم اختيارها
//     setselecteduser(newValue); // `newValue` هي القيمة المختارة
//   };

//   const searchchangetype = (e) => {
//     setsearchtype(e.target.value);
//   };

//   const searchchange = (e) => {
//     setsearch(e.target.value);
//   };

//   const dispatch = useDispatch();

//   // saerch in admin account with email and phone and name

//   // const isNumeric = (str) => /^[0-9]+$/.test(str);
//   // const isValidName = (str) => /^[A-Za-z0-9\s\-,\.]+$/.test(str);
//   // const isEmail = (str) => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(str);

//   // let searchQuery;
//   // if (isNumeric(search)) {

//   //   // إذا كانت المدخلات أرقام (رقم هاتف)، نقوم بالبحث في الـ phone
//   //   searchQuery = `phone=${search}`;
//   // }
//   // else if (isValidName(search)) {
//   //   // إذا كانت المدخلات تحتوي على حروف وأرقام (اسم) أو رموز مقبولة مثل الفاصلة أو النقطة
//   //   searchQuery = `name=${search}`;
//   // }
//   // else if(isEmail(search)) {
//   //   // إذا كان المدخل هو بريد إلكتروني صالح
//   //   searchQuery = `email=${search}`;
//   // }
//   // else
//   // if(selectedIndex===1)
//   // {
//   //   searchQuery=`countryname=${country}`;
//   // }

//   // else {
//   //   // في حالة عدم وجود تطابق (مثل وجود رموز غير معروفة)
//   //   searchQuery = ``;
//   // }

//   //sales data and users data
//   const getsalesandusers = async () => {
//     await dispatch(Get_All_Sales_Action());
//     await dispatch(Getalldatauserlog_forsearch());
//   };

//   useEffect(() => {
//     getsalesandusers();
//   }, []);

//   const ressales = useSelector((state) => state.AllSales.sales);
//   let salesarray = Array.isArray(ressales?.data) ? ressales.data : [];

//   // users
//   const resusers = useSelector((state) => state.AuthRoot.Signup);
//   let usersarray = Array.isArray(resusers?.data) ? resusers.data : [];

//   // ======================================================
//   const handlesearchsubmit = async () => {
//     if (selectedIndex === 1) {
//       // searchquery2=`countryname=${country&country.name?(country.name):null}`

//       await dispatch(
//         GetAllLeadsSearchAction(
//           `limit=${limit}&phone=${country.phone_code ? country.phone_code : null}&leadisactive=true`,
//         ),
//       );
//     } else if (selectedIndex === 0) {
//       await dispatch(
//         GetAllLeadsSearchAction(`limit=${limit}&sales=${selectedSale._id}&leadisactive=true`),
//       );
//     } else if (selectedIndex === 2) {
//       await dispatch(GetAllLeadsSearchAction(`limit=${limit}&dayonly=${value}&leadisactive=true`));
//     } else if (selectedIndex === 3) {
//       const from = new Date(datefrom);
//       from.setHours(0, 0, 0, 0); // بداية اليوم 00:00:00.000Z

//       const to = new Date(dateto);
//       to.setHours(23, 59, 59, 999); // نهاية اليوم 23:59:59.999Z

//       await dispatch(
//         GetAllLeadsSearchAction(
//           `limit=${limit}&date[gte]=${from.toISOString()}&date[lte]=${to.toISOString()}&leadisactive=true`,
//         ),
//       );
//     } else if (selectedIndex === 4) {
//       const from = new Date(datefromwithsales);
//       from.setHours(0, 0, 0, 0); // بداية اليوم 00:00:00.000Z

//       const to = new Date(datetowithsales);
//       to.setHours(23, 59, 59, 999); // نهاية اليوم 23:59:59.999Z
//       const salesId = selectedSale?._id ? selectedSale._id : null; // تأكد من أن القيمة موجودة

//       // إعداد الرابط بناءً على القيم
//       let query = `limit=${limit}&date[gte]=${from.toISOString()}&date[lte]=${to.toISOString()}`;
//       if (salesId) {
//         query += `&sales=${salesId}&leadisactive=true`;
//       }

//       await dispatch(GetAllLeadsSearchAction(`${query}`));
//     } else if (selectedIndex === 5) {
//       await dispatch(
//         GetAllLeadsSearchAction(`limit=${limit}&addby=${selecteduser._id}&leadisactive=true`),
//       );
//     } else if (selectedIndex === 6) {
//       await dispatch(
//         GetAllLeadsSearchAction(
//           `limit=${limit}&lastcommentdate=${lastcommentdate}&leadisactive=true`,
//         ),
//       );
//     }
//   };

//   // const getLeads=async()=>{

//   //       await dispatch(GetAllLeadsSearchAction(`${searchQuery}`))

//   //     }

//   //  useEffect(()=>{

//   //   getLeads();

//   // },[search])

//   const Leads = useSelector((state) => state.Allusers.Get_users);

//   let items = [];

//   if (Leads && Leads.data) {
//     items = Leads.data;
//   }

//   // useEffect(() => {
//   //   // إرسال GET request للحصول على بيانات المستخدم (IP، الموقع، نوع الجهاز)
//   //   // axios.get(`https://apirender8.onrender.com/get-user-info`)
//   //       axios.get(`${db_url}get-user-info`)

//   //     .then(response => {
//   //       setUserInfo(response.data); // تخزين البيانات في الحالة
//   //     })
//   //     .catch(error => {
//   //       console.error("There was an error fetching the user info:", error);
//   //     });
//   // }, []);

//   // ======================================================log out
//   useEffect(() => {
//     const fetchLocation = async () => {
//       try {
//         const response = await axios.get('https://ipinfo.io/json?token=e95a1c99775abd');
//         setLocation(response.data);
//       } catch (error) {
//         console.error('Error fetching location data:', error);
//       }
//     };

//     fetchLocation();
//   }, []);

//   // قيمة السيرفر الحالي
//   // const [serverTime, setServerTime] = useState(null);
//   // useEffect(() => {
//   //   const fetchServerTime = async () => {
//   //     try {
//   //       const response = await axios.get('https://worldtimeapi.org/api/ip');
//   //       setServerTime(response.data.datetime);
//   //     } catch (error) {
//   //       console.error('Error fetching server time:', error);
//   //     }
//   //   };

//   //   fetchServerTime();
//   // }, []);

//   const savedDeviceId = localStorage.getItem('deviceId');
//   const [loadinglogout, setloadinglogout] = useState(true);
//   const logout = async () => {
//     // insert data for user activation when make login
//     //  await dispatch(Add_User_Activation_Logout_Action({
//     //   user_id:user?.data?._id,
//     //   deviceType:isMobile ? 'Mobile' : isTablet ? 'Tablet' : isDesktop ? 'Desktop' : 'Unknown',
//     //   Browser_name:browserName,
//     // EngineName:engineName,
//     // osName:osName,
//     // ip:location.ip,
//     // city:location.city,
//     // region:location.region,
//     // country:location.country,
//     // postalcode:location.postal,
//     // loc:location.loc,
//     // hosetname:location.hostname,
//     // type:"LogOut"
//     // }))
//     // console.log('📱 DeviceId from localStorage:', savedDeviceId);
//     // console.log('👤 User ID:', user?.data?._id);
//     setloadinglogout(true);
//     await dispatch(Logoutsession_one_Device(user?.data?._id, savedDeviceId));
//     setloadinglogout(false);

//     // //delete use active data
//     // localStorage.removeItem('token');
//     // localStorage.removeItem('user');
//     // localStorage.setItem("isLoggedIn", "false");

//     // window.location.href=`#/`;
//   };

//   const reslogout = useSelector((state) => state.All_Users_Devices.User_Devices);

//   useEffect(() => {
//     if (loadinglogout === false) {
//       //  delete use active data
//       localStorage.removeItem('token');
//       localStorage.removeItem('user');
//       localStorage.setItem('isLoggedIn', 'false');

//       window.location.href = `#/`;
//     }
//   }, [loadinglogout]);

//   // const userlogout=useReducer(state=>state.AllUserActivation.user_actiovation)

//   // =====================================

//   const [hash, setHash] = useState(window.location.hash.replace('#', '')); // المسار الحالي بدون #

//   useEffect(() => {
//     const handleHashChange = () => setHash(window.location.hash.replace('#', '')); // تحديث المسار عند التغيير

//     window.addEventListener('hashchange', handleHashChange);

//     return () => {
//       window.removeEventListener('hashchange', handleHashChange);
//     };
//   }, []);

//   useEffect(() => {
//     const navbar = document.getElementById('navbarr');
//     const shouldHide = hash === '' || hash === '/' || hash === '/Login'; // الشرط لإخفاء النافبار

//     if (navbar) {
//       navbar.style.display = shouldHide ? 'none' : 'flex';
//     }

//     setOpenDrawer(!shouldHide); // التحكم في حالة السايدبار أو القائمة الجانبية
//   }, [hash, setOpenDrawer]);

//   const locationn = useLocation();

//   //   useEffect(() => {
//   //     const navbar = document.getElementById("navbarr");
//   //     const path = locationn.hash.replace("#", ""); // إزالة #

//   //     const shouldHide = !path || path === "/" || path === "/Login";

//   //     if (navbar) {
//   //       navbar.style.display = shouldHide ? "none" : "flex";
//   //     }

//   //     setOpenDrawer(!shouldHide);
//   //   }, [locationn.hash]); // التحديث عند تغيير الـ hash

//   //   const [shouldShow, setShouldShow] = useState(true); // حالة لتحديد هل نخفي الـ Navbar أم لا

//   // useEffect(() => {
//   //   const path = locationn.hash.replace("#", ""); // إزالة #

//   //   const shouldHide = !path || path === "/" || path === "/Login";

//   //   // تحديث الحالة بناءً على المسار الحالي
//   //   setShouldShow(!shouldHide);
//   // }, [locationn.hash]); // تحديث عند تغيير المسار

//   // عرض صوره ال profile
//   const profileImage = user?.data?.profileImg
//     ? `/UsersImages/${user.data.profileImg.split('/UsersImages/').pop()}`
//     : null;

//   const getInitials = (name) => {
//     if (!name || typeof name !== 'string') return 'U';
//     return name
//       .split(' ')
//       .filter((word) => word.length > 0)
//       .map((word) => word.charAt(0))
//       .join('')
//       .toUpperCase()
//       .slice(0, 2);
//   };

//   return (
//     <div fluid className="" style={{ position: 'relative' }}>
//       {/* Leftsidebare2 يظهر فوق كل حاجة */}
//       <div
//         style={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           zIndex: 9999,
//           height: '100vh',
//         }}
//       >
//         <Leftsidebare2
//           openDrawer={openDrawer}
//           isMobile={isMobile}
//           toggleDrawer={toggleOffcanvas}
//           setOpenDrawer={setOpenDrawer}
//           setmode={setmode}
//           mode={mode}
//         />
//       </div>

//       <Navbar
//         id="navbarr"
//         expand="lg"
//         className="navbarstyle"
//         style={{
//           backgroundColor: mode === 'dark' ? '#121212' : 'white',
//           borderBottom: mode === 'dark' ? '#121212' : '#ccc',
//           minHeight: '80px',
//           position: 'fixed',
//           zIndex: 1000, // أقل من الـ Leftsidebare2
//         }}
//       >
//         {/* باقي الـ navbar content زي ما هو */}
//         <div
//           className="d-flex align-items-center justify-content-between w-100"
//           style={{
//             marginTop: '0',
//             position: 'relative',
//           }}
//         >
//           {/* Logo */}
//           <Navbar.Brand className="title mx-3" style={{ color: 'white', flexShrink: 0 }}>
//             <img
//               style={{
//                 width: '160px',
//                 zIndex: '3000',
//                 height: 'auto',
//               }}
//               loading="lazy"
//               src={mode === 'light' ? logo : logodark}
//               alt="logo"
//             />
//           </Navbar.Brand>

//           {/* Search Inputs */}
//           {user && user.data ? (
//             user?.data?.role === 'Admin' ? (
//               <div
//                 className="search-container my-2 mx-auto d-flex align-items-center justify-content-center"
//                 style={{
//                   width: '60%',
//                   maxWidth: '600px',
//                   position: 'relative',
//                   borderRadius: '25px',
//                   backgroundColor: mode === 'light' ? '#fff' : '#1e1e1e',
//                   boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
//                   transition: 'all 0.3s ease',
//                 }}
//               >
//                 <SearchIcon
//                   style={{
//                     position: 'absolute',
//                     left: '15px',
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     color: '#0F7687',
//                     fontSize: '22px',
//                     opacity: 0.8,
//                   }}
//                 />
//                 <Form.Control
//                   type="text"
//                   onChange={mainsearchchange}
//                   value={search}
//                   placeholder="Search by Name, Email, Phone, or Unit Number"
//                   aria-label="Search"
//                   style={{
//                     paddingLeft: '45px',
//                     borderRadius: '25px',
//                     height: '45px',
//                     border: '1px solid transparent',
//                     fontSize: '15px',
//                     fontFamily: 'Montserrat, sans-serif',
//                     background: 'transparent',
//                     color: mode === 'light' ? '#333' : '#eee',
//                     width: '100%',
//                     transition: 'all 0.3s ease',
//                   }}
//                   onFocus={(e) => {
//                     e.target.style.border = '1px solid #102dff';
//                     e.target.style.boxShadow = '0 0 8px rgba(15,118,135,0.3)';
//                   }}
//                   onBlur={(e) => {
//                     e.target.style.border = '1px solid transparent';
//                     e.target.style.boxShadow = 'none';
//                   }}
//                 />
//               </div>
//             ) : user?.data?.role === 'Team Leader' ? (
//               <div
//                 className="search-container my-2 mx-auto d-flex align-items-center justify-content-center"
//                 style={{
//                   width: '60%',
//                   maxWidth: '600px',
//                   position: 'relative',
//                   borderRadius: '25px',
//                   backgroundColor: mode === 'light' ? '#fff' : '#1e1e1e',
//                   boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
//                   transition: 'all 0.3s ease',
//                 }}
//               >
//                 <SearchIcon
//                   style={{
//                     position: 'absolute',
//                     left: '15px',
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     color: '#0F7687',
//                     fontSize: '22px',
//                     opacity: 0.8,
//                   }}
//                 />
//                 <Form.Control
//                   type="text"
//                   onChange={searchsaleschange}
//                   value={searchsales}
//                   placeholder="Search About Leads With Name, E-mail, Phone"
//                   aria-label="Search About Leads With Team Leader"
//                   style={{
//                     paddingLeft: '45px',
//                     borderRadius: '25px',
//                     height: '45px',
//                     border: '1px solid transparent',
//                     fontSize: '15px',
//                     fontFamily: 'Montserrat, sans-serif',
//                     background: 'transparent',
//                     color: mode === 'light' ? '#333' : '#eee',
//                     width: '100%',
//                     transition: 'all 0.3s ease',
//                   }}
//                   onFocus={(e) => {
//                     e.target.style.border = '1px solid #102dff';
//                     e.target.style.boxShadow = '0 0 8px rgba(15,118,135,0.3)';
//                   }}
//                   onBlur={(e) => {
//                     e.target.style.border = '1px solid transparent';
//                     e.target.style.boxShadow = 'none';
//                   }}
//                 />
//               </div>
//             ) : user?.data?.role === 'Manager' ? (
//               <div
//                 className="search-container my-2 mx-auto d-flex align-items-center justify-content-center"
//                 style={{
//                   width: '60%',
//                   maxWidth: '600px',
//                   position: 'relative',
//                   borderRadius: '25px',
//                   backgroundColor: mode === 'light' ? '#fff' : '#1e1e1e',
//                   boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
//                   transition: 'all 0.3s ease',
//                 }}
//               >
//                 <SearchIcon
//                   style={{
//                     position: 'absolute',
//                     left: '15px',
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     color: '#0F7687',
//                     fontSize: '22px',
//                     opacity: 0.8,
//                   }}
//                 />
//                 <Form.Control
//                   type="text"
//                   onChange={searchsalesmanagerchange}
//                   value={searchsaleswithmanager}
//                   placeholder="Search About Leads (Name, E-mail, Phone) With Manager"
//                   aria-label="Search About Leads With Manager"
//                   style={{
//                     paddingLeft: '45px',
//                     borderRadius: '25px',
//                     height: '45px',
//                     border: '1px solid transparent',
//                     fontSize: '15px',
//                     fontFamily: 'Montserrat, sans-serif',
//                     background: 'transparent',
//                     color: mode === 'light' ? '#333' : '#eee',
//                     width: '100%',
//                     transition: 'all 0.3s ease',
//                   }}
//                   onFocus={(e) => {
//                     e.target.style.border = '1px solid #102dff';
//                     e.target.style.boxShadow = '0 0 8px rgba(15,118,135,0.3)';
//                   }}
//                   onBlur={(e) => {
//                     e.target.style.border = '1px solid transparent';
//                     e.target.style.boxShadow = 'none';
//                   }}
//                 />
//               </div>
//             ) : user?.data?.role === 'Sales' ? (
//               <div
//                 className="search-container my-2 mx-auto d-flex align-items-center justify-content-center"
//                 style={{
//                   width: '60%',
//                   maxWidth: '600px',
//                   position: 'relative',
//                   borderRadius: '25px',
//                   backgroundColor: mode === 'light' ? '#fff' : '#1e1e1e',
//                   boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
//                   transition: 'all 0.3s ease',
//                 }}
//               >
//                 <SearchIcon
//                   style={{
//                     position: 'absolute',
//                     left: '15px',
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     color: '#0F7687',
//                     fontSize: '22px',
//                     opacity: 0.8,
//                   }}
//                 />
//                 <Form.Control
//                   type="text"
//                   onChange={searchwithsaleschange}
//                   value={searchsalesuser}
//                   placeholder="Search About Leads With Sales"
//                   aria-label="Search About Leads With Sales"
//                   style={{
//                     paddingLeft: '45px',
//                     borderRadius: '25px',
//                     height: '45px',
//                     border: '1px solid transparent',
//                     fontSize: '15px',
//                     fontFamily: 'Montserrat, sans-serif',
//                     background: 'transparent',
//                     color: mode === 'light' ? '#333' : '#eee',
//                     width: '100%',
//                     transition: 'all 0.3s ease',
//                   }}
//                   onFocus={(e) => {
//                     e.target.style.border = '1px solid #102dff';
//                     e.target.style.boxShadow = '0 0 8px rgba(15,118,135,0.3)';
//                   }}
//                   onBlur={(e) => {
//                     e.target.style.border = '1px solid transparent';
//                     e.target.style.boxShadow = 'none';
//                   }}
//                 />
//               </div>
//             ) : user?.data?.role === 'Accountant' ? (
//               <div
//                 className="search-container my-2 mx-auto d-flex align-items-center justify-content-center"
//                 style={{
//                   width: '60%',
//                   maxWidth: '600px',
//                   position: 'relative',
//                   borderRadius: '25px',
//                   backgroundColor: mode === 'light' ? '#fff' : '#1e1e1e',
//                   boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
//                   transition: 'all 0.3s ease',
//                 }}
//               >
//                 <SearchIcon
//                   style={{
//                     position: 'absolute',
//                     left: '15px',
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     color: '#0F7687',
//                     fontSize: '22px',
//                     opacity: 0.8,
//                   }}
//                 />
//                 <Form.Control
//                   type="text"
//                   onChange={searchwithAccountantchange}
//                   value={searchAccountantuser}
//                   placeholder="Search About All Done Deals Lead With Name or Email Or Phone"
//                   aria-label="Search About All Done Deals"
//                   style={{
//                     paddingLeft: '45px',
//                     borderRadius: '25px',
//                     height: '45px',
//                     border: '1px solid transparent',
//                     fontSize: '15px',
//                     fontFamily: 'Montserrat, sans-serif',
//                     background: 'transparent',
//                     color: mode === 'light' ? '#333' : '#eee',
//                     width: '100%',
//                     transition: 'all 0.3s ease',
//                   }}
//                   onFocus={(e) => {
//                     e.target.style.border = '1px solid #102dff';
//                     e.target.style.boxShadow = '0 0 8px rgba(15,118,135,0.3)';
//                   }}
//                   onBlur={(e) => {
//                     e.target.style.border = '1px solid transparent';
//                     e.target.style.boxShadow = 'none';
//                   }}
//                 />
//               </div>
//             ) : user?.data?.role === 'Marketer' ? (
//               <div
//                 className="search-container my-2 mx-auto d-flex align-items-center justify-content-center"
//                 style={{
//                   width: '60%',
//                   maxWidth: '600px',
//                   position: 'relative',
//                   borderRadius: '25px',
//                   backgroundColor: mode === 'light' ? '#fff' : '#1e1e1e',
//                   boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
//                   transition: 'all 0.3s ease',
//                 }}
//               >
//                 <SearchIcon
//                   style={{
//                     position: 'absolute',
//                     left: '15px',
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     color: '#0F7687',
//                     fontSize: '22px',
//                     opacity: 0.8,
//                   }}
//                 />
//                 <Form.Control
//                   type="text"
//                   onChange={searchMarketerchange}
//                   value={searchMarketeruser}
//                   placeholder="Marketer, Search About Lead With Name or Email Or Phone"
//                   aria-label="Marketer Search"
//                   style={{
//                     paddingLeft: '45px',
//                     borderRadius: '25px',
//                     height: '45px',
//                     border: '1px solid transparent',
//                     fontSize: '15px',
//                     fontFamily: 'Montserrat, sans-serif',
//                     background: 'transparent',
//                     color: mode === 'light' ? '#333' : '#eee',
//                     width: '100%',
//                     transition: 'all 0.3s ease',
//                   }}
//                   onFocus={(e) => {
//                     e.target.style.border = '1px solid #102dff';
//                     e.target.style.boxShadow = '0 0 8px rgba(15,118,135,0.3)';
//                   }}
//                   onBlur={(e) => {
//                     e.target.style.border = '1px solid transparent';
//                     e.target.style.boxShadow = 'none';
//                   }}
//                 />
//               </div>
//             ) : null
//           ) : null}

//           {/* Right Section */}
//           <div
//             className="d-flex align-items-center justify-content-center"
//             style={{
//               flexShrink: 0,
//               gap: '15px',
//             }}
//           >
//             {/* Notifications */}
//             <div style={{ margin: '0 10px' }}>
//               <NotificationBell userId={userlogin?.data?._id} />
//             </div>

//             {/* User Avatar */}
//             <Box>
//               <Tooltip title="Account settings">
//                 <IconButton
//                   onClick={handleClickmenue}
//                   size="small"
//                   sx={{
//                     ml: 1,
//                     p: 0,
//                     position: 'relative',
//                     '&:hover': {
//                       '& .avatar-ring': {
//                         transform: 'scale(1.05)',
//                         opacity: 1,
//                       },
//                       '& .avatar-image': {
//                         filter: 'brightness(1.1) drop-shadow(0 0 12px rgba(15, 118, 135, 0.4))',
//                       },
//                       '& .animated-background': {
//                         opacity: 0.8,
//                         transform: 'scale(1.1) rotate(15deg)',
//                       },
//                     },
//                   }}
//                 >
//                   {/* Animated gradient background */}
//                   <Box
//                     className="animated-background"
//                     sx={{
//                       position: 'absolute',
//                       top: '-6px',
//                       left: '-6px',
//                       right: '-6px',
//                       bottom: '-6px',
//                       borderRadius: '50%',
//                       background:
//                         'linear-gradient(45deg, #FF6B6B, #FFD166, #06D6A0, #118AB2, #073B4C)',
//                       backgroundSize: '400% 400%',
//                       zIndex: 0,
//                       opacity: 0.5,
//                       transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
//                       animation: 'gradientFlow 8s ease infinite',
//                       filter: 'blur(6px)',
//                       '@keyframes gradientFlow': {
//                         '0%': {
//                           backgroundPosition: '0% 50%',
//                         },
//                         '50%': {
//                           backgroundPosition: '100% 50%',
//                         },
//                         '100%': {
//                           backgroundPosition: '0% 50%',
//                         },
//                       },
//                     }}
//                   />

//                   {/* Second background layer for more depth */}
//                   <Box
//                     sx={{
//                       position: 'absolute',
//                       top: '-3px',
//                       left: '-3px',
//                       right: '-3px',
//                       bottom: '-3px',
//                       borderRadius: '50%',
//                       background:
//                         'linear-gradient(135deg, rgba(255,215,102,0.7), rgba(6,214,160,0.7))',
//                       zIndex: 0,
//                       opacity: 0.7,
//                       transition: 'all 0.3s ease',
//                     }}
//                   />

//                   {/* Glowing ring */}
//                   <Box
//                     className="avatar-ring"
//                     sx={{
//                       position: 'absolute',
//                       top: '-3px',
//                       left: '-3px',
//                       right: '-3px',
//                       bottom: '-3px',
//                       borderRadius: '50%',
//                       background: 'linear-gradient(45deg, #0F7687, #14b8a6, #0F7687)',
//                       backgroundSize: '300% 300%',
//                       zIndex: 0,
//                       opacity: 0,
//                       transition: 'all 0.3s ease',
//                       animation: 'rotateGradient 2s linear infinite',
//                       '@keyframes rotateGradient': {
//                         '0%': {
//                           backgroundPosition: '0% 50%',
//                         },
//                         '50%': {
//                           backgroundPosition: '100% 50%',
//                         },
//                         '100%': {
//                           backgroundPosition: '0% 50%',
//                         },
//                       },
//                     }}
//                   />

//                   {/* Avatar container */}
//                   <Box
//                     sx={{
//                       position: 'relative',
//                       width: 56,
//                       height: 56,
//                       borderRadius: '50%',
//                       zIndex: 1,
//                       overflow: 'hidden',
//                       backgroundColor:
//                         mode === 'dark' ? 'rgba(30, 30, 40, 0.6)' : 'rgba(255, 255, 255, 0.6)',
//                       backdropFilter: 'blur(4px)',
//                       border: `2px solid ${mode === 'dark' ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.4)'}`,
//                       boxShadow:
//                         mode === 'dark'
//                           ? '0 4px 20px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.1)'
//                           : '0 4px 20px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.6)',
//                     }}
//                   >
//                     {/* Avatar - يظهر الصورة إذا موجودة أو الأحرف الأولى */}
//                     {profileImage ? (
//                       <Avatar
//                         className="avatar-image"
//                         sx={{
//                           width: '100%',
//                           height: '100%',
//                           border: `2px solid ${mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(255,255,255,0.3)'}`,
//                           boxShadow:
//                             mode === 'dark'
//                               ? '0 4px 15px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)'
//                               : '0 4px 15px rgba(15, 118, 135, 0.2), inset 0 1px 0 rgba(255,255,255,0.4)',
//                           transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                           position: 'relative',
//                           zIndex: 1,
//                         }}
//                         src={profileImage}
//                         alt={user?.data?.name || 'User'}
//                         onError={(e) => {
//                           // إذا فشل تحميل الصورة، اعرض الأحرف الأولى
//                           e.target.style.display = 'none';
//                         }}
//                       >
//                         {/* Fallback initials if image fails */}
//                         <Typography
//                           sx={{
//                             fontSize: '1.4rem',
//                             fontWeight: '700',
//                             color: 'white',
//                             fontFamily: 'Montserrat',
//                           }}
//                         >
//                           {getInitials(user?.data?.name)}
//                         </Typography>
//                       </Avatar>
//                     ) : (
//                       <Avatar
//                         className="avatar-image"
//                         sx={{
//                           width: '100%',
//                           height: '100%',
//                           border: `2px solid ${mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(255,255,255,0.3)'}`,
//                           background: 'linear-gradient(135deg, #FF6B6B, #FFD166)',
//                           boxShadow:
//                             mode === 'dark'
//                               ? '0 4px 15px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)'
//                               : '0 4px 15px rgba(255,107,107, 0.3), inset 0 1px 0 rgba(255,255,255,0.4)',
//                           transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                           position: 'relative',
//                           zIndex: 1,
//                         }}
//                       >
//                         <Typography
//                           sx={{
//                             fontSize: '1.4rem',
//                             fontWeight: '700',
//                             color: 'white',
//                             fontFamily: 'Montserrat',
//                             textShadow: '0 2px 4px rgba(0,0,0,0.3)',
//                           }}
//                         >
//                           {getInitials(user?.data?.name)}
//                         </Typography>
//                       </Avatar>
//                     )}

//                     {/* Animated particles background */}
//                     <Box
//                       sx={{
//                         position: 'absolute',
//                         top: 0,
//                         left: 0,
//                         width: '100%',
//                         height: '100%',
//                         zIndex: 0,
//                         overflow: 'hidden',
//                         borderRadius: '50%',
//                         '&::before, &::after': {
//                           content: '""',
//                           position: 'absolute',
//                           width: '20px',
//                           height: '20px',
//                           borderRadius: '50%',
//                           background:
//                             'radial-gradient(circle, rgba(255,255,255,0.8) 0%, transparent 70%)',
//                           animation: 'floatParticle 6s ease-in-out infinite',
//                         },
//                         '&::before': {
//                           top: '10%',
//                           left: '20%',
//                           animationDelay: '0s',
//                           background:
//                             'radial-gradient(circle, rgba(255,209,102,0.8) 0%, transparent 70%)',
//                         },
//                         '&::after': {
//                           bottom: '15%',
//                           right: '25%',
//                           animationDelay: '3s',
//                           background:
//                             'radial-gradient(circle, rgba(6,214,160,0.8) 0%, transparent 70%)',
//                         },
//                         '@keyframes floatParticle': {
//                           '0%, 100%': {
//                             transform: 'translateY(0px) scale(1)',
//                             opacity: 0.5,
//                           },
//                           '50%': {
//                             transform: 'translateY(-15px) scale(1.2)',
//                             opacity: 0.8,
//                           },
//                         },
//                       }}
//                     />

//                     {/* Shine effect */}
//                     <Box
//                       className="avatar-shine"
//                       sx={{
//                         position: 'absolute',
//                         top: '15%',
//                         left: '15%',
//                         width: '30%',
//                         height: '30%',
//                         borderRadius: '50%',
//                         background:
//                           'radial-gradient(circle, rgba(255,255,255,0.8) 0%, transparent 70%)',
//                         filter: 'blur(1px)',
//                         zIndex: 2,
//                         pointerEvents: 'none',
//                         opacity: 0.6,
//                         animation: 'pulseShine 3s ease-in-out infinite',
//                         '@keyframes pulseShine': {
//                           '0%, 100%': {
//                             opacity: 0.4,
//                             transform: 'scale(1)',
//                           },
//                           '50%': {
//                             opacity: 0.8,
//                             transform: 'scale(1.2)',
//                           },
//                         },
//                       }}
//                     />

//                     {/* Online status indicator */}
//                     <Box
//                       sx={{
//                         position: 'absolute',
//                         bottom: '4px',
//                         right: '4px',
//                         width: '14px',
//                         height: '14px',
//                         borderRadius: '50%',
//                         backgroundColor: '#10b981',
//                         border: `2px solid ${mode === 'dark' ? '#1a202c' : '#ffffff'}`,
//                         zIndex: 3,
//                         boxShadow: '0 0 10px #10b981',
//                         animation: 'pulseStatus 2s ease-in-out infinite',
//                         '&::after': {
//                           content: '""',
//                           position: 'absolute',
//                           top: '2px',
//                           left: '2px',
//                           width: '6px',
//                           height: '6px',
//                           borderRadius: '50%',
//                           backgroundColor: 'white',
//                           opacity: 0.9,
//                         },
//                         '@keyframes pulseStatus': {
//                           '0%, 100%': {
//                             boxShadow: '0 0 10px #10b981',
//                           },
//                           '50%': {
//                             boxShadow: '0 0 15px #10b981',
//                           },
//                         },
//                       }}
//                     />
//                   </Box>
//                 </IconButton>
//               </Tooltip>
//             </Box>

//             {/* User Menu */}
//             <Menu
//               anchorEl={anchorElmenue}
//               open={openmenue}
//               onClose={handleClosemenue}
//               onClick={handleClosemenue}
//               slotProps={{
//                 paper: {
//                   elevation: 8,
//                   sx: {
//                     overflow: 'visible',
//                     minWidth: 280,
//                     borderRadius: '16px',
//                     marginTop: 2,
//                     background:
//                       mode === 'dark'
//                         ? 'linear-gradient(145deg, #1a202c, #2d3748)'
//                         : 'linear-gradient(145deg, #ffffff, #f7fafc)',
//                     boxShadow:
//                       mode === 'dark'
//                         ? '0 20px 60px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
//                         : '0 20px 60px rgba(15, 118, 135, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.8)',
//                     border:
//                       mode === 'dark'
//                         ? '1px solid rgba(255, 255, 255, 0.1)'
//                         : '1px solid rgba(15, 118, 135, 0.1)',
//                     '&::before': {
//                       content: '""',
//                       display: 'block',
//                       position: 'absolute',
//                       top: -6,
//                       right: 20,
//                       width: 12,
//                       height: 12,
//                       background: mode === 'dark' ? '#2d3748' : '#ffffff',
//                       transform: 'translateY(-50%) rotate(45deg)',
//                       zIndex: 0,
//                       borderTop:
//                         mode === 'dark'
//                           ? '1px solid rgba(255, 255, 255, 0.1)'
//                           : '1px solid rgba(15, 118, 135, 0.1)',
//                       borderLeft:
//                         mode === 'dark'
//                           ? '1px solid rgba(255, 255, 255, 0.1)'
//                           : '1px solid rgba(15, 118, 135, 0.1)',
//                     },
//                   },
//                 },
//               }}
//               transformOrigin={{ horizontal: 'right', vertical: 'top' }}
//               anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
//               transitionDuration={300}
//             >
//               {/* User Profile Header */}
//               <MenuItem
//                 onClick={handleClosemenue}
//                 sx={{
//                   py: 2,
//                   px: 2.5,
//                   background:
//                     mode === 'dark'
//                       ? 'linear-gradient(90deg, rgba(15, 118, 135, 0.2), transparent)'
//                       : 'linear-gradient(90deg, rgba(15, 118, 135, 0.05), transparent)',
//                   borderBottom:
//                     mode === 'dark'
//                       ? '1px solid rgba(255, 255, 255, 0.05)'
//                       : '1px solid rgba(15, 118, 135, 0.05)',
//                   '&:hover': {
//                     background:
//                       mode === 'dark' ? 'rgba(15, 118, 135, 0.1)' : 'rgba(15, 118, 135, 0.03)',
//                   },
//                 }}
//               >
//                 <Avatar
//                   sx={{
//                     width: 48,
//                     height: 48,
//                     mr: 2,
//                     border: `2px solid ${mode === 'dark' ? '#0F7687' : '#0F7687'}`,
//                     boxShadow: '0 4px 12px rgba(15, 118, 135, 0.3)',
//                   }}
//                   src={profileImage || '/default-avatar.png'}
//                 />
//                 <Box>
//                   <Typography
//                     variant="subtitle1"
//                     fontWeight="700"
//                     sx={{
//                       color: mode === 'dark' ? '#e2e8f0' : '#0F7687',
//                       fontFamily: 'Montserrat',
//                       fontSize: '1rem',
//                       letterSpacing: '0.5px',
//                     }}
//                   >
//                     {user?.data?.name || 'User'}
//                   </Typography>
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       color: mode === 'dark' ? '#a0aec0' : '#718096',
//                       fontFamily: 'Montserrat',
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 0.5,
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         width: 8,
//                         height: 8,
//                         borderRadius: '50%',
//                         backgroundColor: '#10b981',
//                         display: 'inline-block',
//                       }}
//                     />
//                     {user?.data?.role || 'User Role'}
//                   </Typography>
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       color: mode === 'dark' ? '#718096' : '#a0aec0',
//                       fontFamily: 'Montserrat',
//                       display: 'block',
//                       mt: 0.5,
//                       fontSize: '0.75rem',
//                     }}
//                   >
//                     {user?.data?.email || ''}
//                   </Typography>
//                 </Box>
//               </MenuItem>

//               {/* My Account Link */}
//               <a
//                 href="#/MyAccount"
//                 style={{
//                   textDecoration: 'none',
//                   fontFamily: 'Montserrat',
//                   display: 'block',
//                 }}
//               >
//                 <MenuItem
//                   sx={{
//                     py: 1.8,
//                     px: 2.5,
//                     fontFamily: 'Montserrat',
//                     transition: 'all 0.2s ease',
//                     '&:hover': {
//                       background:
//                         mode === 'dark' ? 'rgba(15, 118, 135, 0.15)' : 'rgba(15, 118, 135, 0.05)',
//                       transform: 'translateX(5px)',
//                       '& .menu-icon': {
//                         transform: 'scale(1.1)',
//                         color: '#0F7687',
//                       },
//                     },
//                   }}
//                   onClick={handleClosemenue}
//                 >
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 2,
//                       width: '100%',
//                     }}
//                   >
//                     <Box
//                       className="menu-icon"
//                       sx={{
//                         width: 36,
//                         height: 36,
//                         borderRadius: '10px',
//                         background:
//                           mode === 'dark' ? 'rgba(15, 118, 135, 0.2)' : 'rgba(15, 118, 135, 0.1)',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         transition: 'all 0.2s ease',
//                       }}
//                     >
//                       <AccountCircleIcon
//                         sx={{
//                           color: mode === 'dark' ? '#90caf9' : '#0F7687',
//                           fontSize: '1.2rem',
//                         }}
//                       />
//                     </Box>
//                     <Typography
//                       sx={{
//                         color: mode === 'dark' ? '#e2e8f0' : '#2d3748',
//                         fontFamily: 'Montserrat',
//                         fontWeight: '500',
//                         flex: 1,
//                       }}
//                     >
//                       My Account
//                     </Typography>
//                     <ChevronRightIcon
//                       sx={{
//                         color: mode === 'dark' ? '#718096' : '#a0aec0',
//                         fontSize: '1.2rem',
//                       }}
//                     />
//                   </Box>
//                 </MenuItem>
//               </a>

//               {/* Add Client Link */}
//               <a
//                 href="#/addclient"
//                 style={{
//                   textDecoration: 'none',
//                   fontFamily: 'Montserrat',
//                   display: 'block',
//                 }}
//               >
//                 <MenuItem
//                   sx={{
//                     py: 1.8,
//                     px: 2.5,
//                     fontFamily: 'Montserrat',
//                     transition: 'all 0.2s ease',
//                     '&:hover': {
//                       background:
//                         mode === 'dark' ? 'rgba(168, 85, 247, 0.15)' : 'rgba(168, 85, 247, 0.05)',
//                       transform: 'translateX(5px)',
//                       '& .menu-icon': {
//                         transform: 'scale(1.1)',
//                         color: '#a855f7',
//                       },
//                     },
//                   }}
//                   onClick={handleClosemenue}
//                 >
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 2,
//                       width: '100%',
//                     }}
//                   >
//                     <Box
//                       className="menu-icon"
//                       sx={{
//                         width: 36,
//                         height: 36,
//                         borderRadius: '10px',
//                         background:
//                           mode === 'dark' ? 'rgba(168, 85, 247, 0.2)' : 'rgba(168, 85, 247, 0.1)',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         transition: 'all 0.2s ease',
//                       }}
//                     >
//                       <PersonAddAltIcon
//                         sx={{
//                           color: mode === 'dark' ? '#c084fc' : '#a855f7',
//                           fontSize: '1.2rem',
//                         }}
//                       />
//                     </Box>
//                     <Typography
//                       sx={{
//                         color: mode === 'dark' ? '#e2e8f0' : '#2d3748',
//                         fontFamily: 'Montserrat',
//                         fontWeight: '500',
//                         flex: 1,
//                       }}
//                     >
//                       Create New Lead
//                     </Typography>
//                     <ChevronRightIcon
//                       sx={{
//                         color: mode === 'dark' ? '#c084fc' : '#a855f7',
//                         fontSize: '1.2rem',
//                       }}
//                     />
//                   </Box>
//                 </MenuItem>
//               </a>

//               {/* My Leads / Admin Dashboard Link */}
//               {user && user.data && (
//                 <a
//                   href={
//                     user.data.role === 'Sales'
//                       ? '#/AllLeadsForSales'
//                       : user.data.role === 'Team Leader'
//                         ? '#/AllLeadsForTeamLeader'
//                         : user.data.role === 'Manager'
//                           ? '#/LeadsForManagers'
//                           : user.data.role === 'Accountant'
//                             ? '#/LeadsForAccountant'
//                             : user.data.role === 'Marketer'
//                               ? '#/ALLLeadsForMarketer'
//                               : user.data.role === 'Admin'
//                                 ? '#/AllLeadsForAdmin'
//                                 : '#'
//                   }
//                   style={{
//                     textDecoration: 'none',
//                     fontFamily: 'Montserrat',
//                     display: 'block',
//                   }}
//                 >
//                   <MenuItem
//                     sx={{
//                       py: 1.8,
//                       px: 2.5,
//                       fontFamily: 'Montserrat',
//                       transition: 'all 0.2s ease',
//                       '&:hover': {
//                         background:
//                           mode === 'dark' ? 'rgba(59, 130, 246, 0.15)' : 'rgba(59, 130, 246, 0.05)',
//                         transform: 'translateX(5px)',
//                         '& .menu-icon': {
//                           transform: 'scale(1.1)',
//                           color: '#3b82f6',
//                         },
//                       },
//                     }}
//                     onClick={handleClosemenue}
//                   >
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: 2,
//                         width: '100%',
//                       }}
//                     >
//                       <Box
//                         className="menu-icon"
//                         sx={{
//                           width: 36,
//                           height: 36,
//                           borderRadius: '10px',
//                           background:
//                             mode === 'dark' ? 'rgba(59, 130, 246, 0.2)' : 'rgba(59, 130, 246, 0.1)',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           transition: 'all 0.2s ease',
//                         }}
//                       >
//                         <ListAltIcon
//                           sx={{
//                             color: mode === 'dark' ? '#93c5fd' : '#3b82f6',
//                             fontSize: '1.2rem',
//                           }}
//                         />
//                       </Box>
//                       <Typography
//                         sx={{
//                           color: mode === 'dark' ? '#e2e8f0' : '#2d3748',
//                           fontFamily: 'Montserrat',
//                           fontWeight: '500',
//                           flex: 1,
//                         }}
//                       >
//                         {user.data.role === 'Admin'
//                           ? 'All Leads'
//                           : ['Sales', 'Team Leader', 'Manager', 'Accountant', 'Marketer'].includes(
//                                 user.data.role,
//                               )
//                             ? 'My Leads'
//                             : ''}
//                       </Typography>
//                       <ChevronRightIcon
//                         sx={{
//                           color: mode === 'dark' ? '#93c5fd' : '#3b82f6',
//                           fontSize: '1.2rem',
//                         }}
//                       />
//                     </Box>
//                   </MenuItem>
//                 </a>
//               )}

//               <Divider
//                 sx={{
//                   my: 1,
//                   borderColor:
//                     mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(15, 118, 135, 0.05)',
//                 }}
//               />

//               {/* crm Data */}

//               {/* {user && user.data && (
//     <a 
//       href={
//         user.data.role === "Sales" ? "#/SalesQuickNumberCRMData" :
//         user.data.role === "Team Leader" ? "#/TeamLeaderQuickNumbersCRMData" :
//         // user.data.role === "Manager" ? "#/LeadsForManagers" :
//         // user.data.role === "Accountant" ? "#/LeadsForAccountant" :
//         // user.data.role === "Marketer" ? "#/ALLLeadsForMarketer" :
//         user.data.role === "Admin" ? "#/AllLeadsForAdminCRMDataQuickNumbers" :
//         "#"
//       }
//       style={{ 
//         textDecoration: 'none',
//         fontFamily: 'Montserrat',
//         display: 'block',
//       }}
//     >
//       <MenuItem 
//         sx={{ 
//           py: 1.8,
//           px: 2.5,
//           fontFamily: 'Montserrat',
//           transition: 'all 0.2s ease',
//           '&:hover': {
//             background: mode === 'dark' 
//               ? 'rgba(59, 130, 246, 0.15)' 
//               : 'rgba(59, 130, 246, 0.05)',
//             transform: 'translateX(5px)',
//             '& .menu-icon': {
//               transform: 'scale(1.1)',
//               color: '#3b82f6',
//             }
//           }
//         }}
//         onClick={handleClosemenue}
//       >
//         <Box 
//           sx={{ 
//             display: 'flex',
//             alignItems: 'center',
//             gap: 2,
//             width: '100%',
//           }}
//         >
//           <Box 
//             className="menu-icon"
//             sx={{
//               width: 36,
//               height: 36,
//               borderRadius: '10px',
//               background: mode === 'dark' 
//                 ? 'rgba(59, 130, 246, 0.2)' 
//                 : 'rgba(59, 130, 246, 0.1)',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               transition: 'all 0.2s ease',
//             }}
//           >
//             <ListAltIcon 
//               sx={{ 
//                 color: mode === 'dark' ? '#93c5fd' : '#3b82f6',
//                 fontSize: '1.2rem',
//               }} 
//             />
//           </Box>
//           <Typography 
//             sx={{ 
//               color: mode === 'dark' ? '#e2e8f0' : '#2d3748',
//               fontFamily: 'Montserrat',
//               fontWeight: '500',
//               flex: 1,
//             }}
//           >
//             {user.data.role === "Admin" 
//               ? "Data Center" 
//               : ["Sales", "Team Leader", "Manager", "Marketer"].includes(user.data.role)
//                 ? "Data Center"
//                 : ""}
//           </Typography>
//           <ChevronRightIcon 
//             sx={{ 
//               color: mode === 'dark' ? '#93c5fd' : '#3b82f6',
//               fontSize: '1.2rem',
//             }} 
//           />
//         </Box>
//       </MenuItem>
//     </a>
//   )} */}

//               {user && user.data && user.data.role !== 'Accountant' && (
//                 <a
//                   href={
//                     user.data.role === 'Sales'
//                       ? '#/SalesQuickNumberCRMData'
//                       : user.data.role === 'Team Leader'
//                         ? '#/TeamLeaderQuickNumbersCRMData'
//                         : // user.data.role === "Manager" ? "#/LeadsForManagers" :
//                           // user.data.role === "Marketer" ? "#/ALLLeadsForMarketer" :
//                           user.data.role === 'Admin'
//                           ? '#/AllLeadsForAdminCRMDataQuickNumbers'
//                           : '#'
//                   }
//                   style={{
//                     textDecoration: 'none',
//                     fontFamily: 'Montserrat',
//                     display: 'block',
//                   }}
//                 >
//                   <MenuItem
//                     sx={{
//                       py: 1.8,
//                       px: 2.5,
//                       fontFamily: 'Montserrat',
//                       transition: 'all 0.2s ease',
//                       '&:hover': {
//                         background:
//                           mode === 'dark' ? 'rgba(59, 130, 246, 0.15)' : 'rgba(59, 130, 246, 0.05)',
//                         transform: 'translateX(5px)',
//                         '& .menu-icon': {
//                           transform: 'scale(1.1)',
//                           color: '#3b82f6',
//                         },
//                       },
//                     }}
//                     onClick={handleClosemenue}
//                   >
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: 2,
//                         width: '100%',
//                       }}
//                     >
//                       <Box
//                         className="menu-icon"
//                         sx={{
//                           width: 36,
//                           height: 36,
//                           borderRadius: '10px',
//                           background:
//                             mode === 'dark' ? 'rgba(59, 130, 246, 0.2)' : 'rgba(59, 130, 246, 0.1)',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           transition: 'all 0.2s ease',
//                         }}
//                       >
//                         <ListAltIcon
//                           sx={{
//                             color: mode === 'dark' ? '#93c5fd' : '#3b82f6',
//                             fontSize: '1.2rem',
//                           }}
//                         />
//                       </Box>
//                       <Typography
//                         sx={{
//                           color: mode === 'dark' ? '#e2e8f0' : '#2d3748',
//                           fontFamily: 'Montserrat',
//                           fontWeight: '500',
//                           flex: 1,
//                         }}
//                       >
//                         Data Center
//                       </Typography>
//                       <ChevronRightIcon
//                         sx={{
//                           color: mode === 'dark' ? '#93c5fd' : '#3b82f6',
//                           fontSize: '1.2rem',
//                         }}
//                       />
//                     </Box>
//                   </MenuItem>
//                 </a>
//               )}

//               <Divider
//                 sx={{
//                   my: 1,
//                   borderColor:
//                     mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(15, 118, 135, 0.05)',
//                 }}
//               />

//               {/* Logout Button */}
//               <MenuItem
//                 onClick={logout}
//                 sx={{
//                   py: 1.8,
//                   px: 2.5,
//                   fontFamily: 'Montserrat',
//                   transition: 'all 0.2s ease',
//                   mt: 1,
//                   '&:hover': {
//                     background:
//                       mode === 'dark' ? 'rgba(239, 68, 68, 0.15)' : 'rgba(239, 68, 68, 0.05)',
//                     transform: 'translateX(5px)',
//                     '& .menu-icon': {
//                       transform: 'scale(1.1)',
//                       color: '#ef4444',
//                     },
//                   },
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 2,
//                     width: '100%',
//                   }}
//                 >
//                   <Box
//                     className="menu-icon"
//                     sx={{
//                       width: 36,
//                       height: 36,
//                       borderRadius: '10px',
//                       background:
//                         mode === 'dark' ? 'rgba(239, 68, 68, 0.2)' : 'rgba(239, 68, 68, 0.1)',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       transition: 'all 0.2s ease',
//                     }}
//                   >
//                     <LogoutIcon
//                       sx={{
//                         color: mode === 'dark' ? '#f87171' : '#ef4444',
//                         fontSize: '1.2rem',
//                       }}
//                     />
//                   </Box>
//                   <Typography
//                     sx={{
//                       color: mode === 'dark' ? '#f87171' : '#ef4444',
//                       fontFamily: 'Montserrat',
//                       fontWeight: '500',
//                       flex: 1,
//                     }}
//                   >
//                     Logout
//                   </Typography>
//                   <ChevronRightIcon
//                     sx={{
//                       color: mode === 'dark' ? '#f87171' : '#ef4444',
//                       fontSize: '1.2rem',
//                     }}
//                   />
//                 </Box>
//               </MenuItem>

//               {/* Footer */}
//               <Box
//                 sx={{
//                   py: 1.5,
//                   px: 2.5,
//                   borderTop:
//                     mode === 'dark'
//                       ? '1px solid rgba(255, 255, 255, 0.05)'
//                       : '1px solid rgba(15, 118, 135, 0.05)',
//                   background: mode === 'dark' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(15, 118, 135, 0.02)',
//                 }}
//               >
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     color: mode === 'dark' ? '#718096' : '#a0aec0',
//                     fontFamily: 'Montserrat',
//                     fontSize: '0.7rem',
//                     display: 'block',
//                     textAlign: 'center',
//                   }}
//                 >
//                   © {new Date().getFullYear()} Realatix CRM
//                 </Typography>
//               </Box>
//             </Menu>
//           </div>
//         </div>
//       </Navbar>
//     </div>
//   );
// };























// 20-5-2026
// import React, { useEffect, useState } from 'react';
// import {
//   Box, Typography, IconButton, Avatar, Tooltip,
//   Menu, MenuItem, Divider, InputBase,
// } from '@mui/material';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation, useNavigate } from 'react-router-dom';

// import SearchIcon                from '@mui/icons-material/Search';
// import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
// import PersonAddAltIcon          from '@mui/icons-material/PersonAddAlt';
// import ListAltIcon               from '@mui/icons-material/ListAlt';
// import LogoutIcon                from '@mui/icons-material/Logout';
// import ChevronRightIcon          from '@mui/icons-material/ChevronRight';

// import { Get_All_Sales_Action }          from '../Redux/Actions/SalesAction';
// import { Getalldatauserlog_forsearch }   from '../Redux/Actions/AuthAction';
// import { Logoutsession_one_Device }      from '../Redux/Actions/Devices_Action';
// import { Leftsidebare2 }                 from '../Utility/Leftsidebare2';
// import NotificationBell                  from '../Pages/NotificationBell';

// // ─── tokens ───────────────────────────────────────────────────────────────────
// const C = {
//   bg:                '#FFFFFF',
//   border:            '#EAECF0',
//   text:              '#101828',
//   textMuted:         '#667085',
//   accent:            '#1A3ECF',
//   accentSoft:        '#EEF1FD',
//   searchBg:          '#F9FAFB',
//   searchBorder:      '#EAECF0',
//   searchBorderFocus: '#1A3ECF',
//   iconHover:         '#F2F4F7',
// };

// const NAVBAR_HEIGHT    = 64;
// const SIDEBAR_EXPANDED = 242;
// const SIDEBAR_COLLAPSED = 64;

// // ─── search config per role ───────────────────────────────────────────────────
// const SEARCH_CONFIG = {
//   Admin:         { placeholder: 'Global search for leads or properties...', storageKey: 'mainsearchstorage',             event: 'mainsearchupdated' },
//   'Team Leader': { placeholder: 'Search leads by name, email or phone...',  storageKey: 'searchsalesstorage',            event: 'searchsalesUpdated' },
//   Manager:       { placeholder: 'Search leads by name, email or phone...',  storageKey: 'searchsalesstoragewithmanager', event: 'searchsalesmanagerUpdated' },
//   Sales:         { placeholder: 'Search leads by name, email or phone...',  storageKey: 'searchsalesuserstorage',        event: 'searchsalesuserstorageUpdate' },
//   Accountant:    { placeholder: 'Search done deals by name, email or phone...', storageKey: 'searchAccountantuserstorage', event: 'searchAccountantuserstorageUpdate' },
//   Marketer:      { placeholder: 'Search leads by name, email or phone...',  storageKey: 'searchMarketerstorage',         event: 'searchMarketerUpdated' },
// };

// const LEADS_ROUTE = {
//   Admin: '/AllLeadsForAdmin', Sales: '/AllLeadsForSales',
//   'Team Leader': '/AllLeadsForTeamLeader', Manager: '/LeadsForManagers',
//   Accountant: '/LeadsForAccountant',       Marketer: '/ALLLeadsForMarketer',
// };

// const DATA_CENTER_ROUTE = {
//   Admin: '/AllLeadsForAdminCRMDataQuickNumbers',
//   Sales: '/SalesQuickNumberCRMData',
//   'Team Leader': '/TeamLeaderQuickNumbersCRMData',
// };

// const getInitials = (name = '') =>
//   name.split(' ').filter(Boolean).map(w => w[0]).join('').toUpperCase().slice(0, 2) || 'U';

// // ─── SmartSearch ──────────────────────────────────────────────────────────────
// const SmartSearch = ({ role }) => {
//   const cfg = SEARCH_CONFIG[role];
//   const [val,     setVal]     = useState(localStorage.getItem(cfg?.storageKey) || '');
//   const [focused, setFocused] = useState(false);

//   if (!cfg) return null;

//  const handleChange = (e) => {
//     const v = e.target.value;
//     setVal(v);
//     localStorage.setItem(cfg.storageKey, v); // خلي الـ storage بالقيمة الأصلية
//     window.dispatchEvent(new Event(cfg.event));
// };

//   return (
//     <Box sx={{
//       display: 'flex', alignItems: 'center',
//       flex: 1, maxWidth: 520,
//       px: '12px', height: '38px',
//       bgcolor: focused ? '#fff' : C.searchBg,
//       border: `1px solid ${focused ? C.searchBorderFocus : C.searchBorder}`,
//       borderRadius: '8px',
//       transition: 'all 0.18s',
//       boxShadow: focused ? `0 0 0 3px ${C.accentSoft}` : 'none',
//       gap: '8px',
//     }}>
//       <SearchIcon sx={{
//         fontSize: '17px',
//         color: focused ? C.accent : C.textMuted,
//         flexShrink: 0, transition: 'color 0.18s',
//       }} />
//       <InputBase
//         value={val}
//         onChange={handleChange}
//         onFocus={() => setFocused(true)}
//         onBlur={() => setFocused(false)}
//         placeholder={cfg.placeholder}
//         sx={{
//           flex: 1, fontSize: '13.5px',
//           fontFamily: "'DM Sans', sans-serif",
//           color: C.text,
//           '& input::placeholder': { color: C.textMuted, opacity: 1 },
//           '& input': { padding: 0 },
//         }}
//       />
//     </Box>
//   );
// };

// // ─── DropdownItem ─────────────────────────────────────────────────────────────
// const DropdownItem = ({ icon, label, onClick, danger }) => (
//   <MenuItem onClick={onClick} sx={{
//     px: 2, py: '9px',
//     display: 'flex', alignItems: 'center', gap: 1.5,
//     transition: 'background 0.15s',
//     '&:hover': { bgcolor: danger ? '#FEF3F2' : '#F9FAFB' },
//     '& .icon': { color: danger ? '#D92D20' : '#667085', display: 'flex', alignItems: 'center' },
//     '&:hover .icon': { color: danger ? '#B42318' : '#344054' },
//   }}>
//     <Box className="icon">{icon}</Box>
//     <Typography sx={{
//       flex: 1, fontSize: '13.5px', fontWeight: 400,
//       fontFamily: "'DM Sans', sans-serif",
//       color: danger ? '#D92D20' : '#344054',
//     }}>
//       {label}
//     </Typography>
//     <ChevronRightIcon sx={{ fontSize: '16px', color: danger ? '#D92D20' : '#D0D5DD' }} />
//   </MenuItem>
// );

// // ─── Main ─────────────────────────────────────────────────────────────────────
// export const Navbarheader = ({ setmode, mode }) => {
//   const dispatch  = useDispatch();
//   const locationn = useLocation();
//   const navigate  = useNavigate();

//   const [user,          setUser]          = useState(null);
//   const [userlogin,     setUserlogin]     = useState(null);
//   const [isMobile,      setIsMobile]      = useState(false);
//   const [openDrawer,    setOpenDrawer]    = useState(false);
//   const [sidebarExpanded, setSidebarExpanded] = useState(true); // ← tracks sidebar state
//   const [menuAnchor,    setMenuAnchor]    = useState(null);
//   const [loadinglogout, setLoadinglogout] = useState(true);

//   const savedDeviceId = localStorage.getItem('deviceId');

//   useEffect(() => {
//     const u = JSON.parse(localStorage.getItem('user'));
//     if (u) { setUser(u); setUserlogin(u); }
//   }, []);

//   useEffect(() => {
//     const check = () => {
//       const mobile = window.innerWidth < 600;
//       setIsMobile(mobile);
//       setOpenDrawer(!mobile);
//     };
//     check();
//     window.addEventListener('resize', check);
//     return () => window.removeEventListener('resize', check);
//   }, []);

//   // useEffect(() => {
//   //   const path = locationn.pathname;
//   //   const hide = path === '/' || path === '/Login';
//   //   const navbar = document.getElementById('navbarr');
//   //   if (navbar) navbar.style.display = hide ? 'none' : 'flex';
//   //   setOpenDrawer(!hide);
//   // }, [locationn.pathname]);
//   // كمّل بس الـ openDrawer logic
// useEffect(() => {
//   const path = locationn.pathname;
//   setOpenDrawer(path !== '/' && path !== '/Login');
// }, [locationn.pathname]);

//   useEffect(() => {
//     dispatch(Get_All_Sales_Action());
//     dispatch(Getalldatauserlog_forsearch());
//   }, []);

//   const logout = async () => {
//     setLoadinglogout(true);
//     await dispatch(Logoutsession_one_Device(user?.data?._id, savedDeviceId));
//     setLoadinglogout(false);
//   };

//   useEffect(() => {
//     if (!loadinglogout) {
//       localStorage.removeItem('token');
//       localStorage.removeItem('user');
//       localStorage.setItem('isLoggedIn', 'false');
//       window.location.href = '#/';
//     }
//   }, [loadinglogout]);

//   const role           = user?.data?.role;
//   const userName       = user?.data?.name || 'User';
//   const userEmail      = user?.data?.email || '';
//   const profileImage   = user?.data?.profileImg
//     ? `/UsersImages/${user.data.profileImg.split('/UsersImages/').pop()}`
//     : null;
//   const leadsRoute     = LEADS_ROUTE[role];
//   const dataCenterRoute = DATA_CENTER_ROUTE[role];

//   // sidebar width changes with expanded state
//   const sidebarW = sidebarExpanded ? SIDEBAR_EXPANDED : SIDEBAR_COLLAPSED;

//   return (
//     <Box sx={{ position: 'relative' }}>

//       {/* ── Sidebar — passes expanded state up via callback ── */}
//       <Box sx={{ position: 'fixed', top: 0, left: 0, zIndex: 1200, height: '100vh' }}>
//         <Leftsidebare2
//           openDrawer={openDrawer}
//           isMobile={isMobile}
//           toggleDrawer={() => setOpenDrawer(p => !p)}
//           setOpenDrawer={setOpenDrawer}
//           setmode={setmode}
//           mode={mode}
//           onExpandedChange={setSidebarExpanded}   // ← new prop
//         />
//       </Box>

//       {/* ── Navbar ── */}
//       <Box
//         id="navbarr"
//         component="header"
//         sx={{
//           position: 'fixed',
//           top: 0, left: 0, right: 0,
//           zIndex: 1100,
//           height: `${NAVBAR_HEIGHT}px`,
//           bgcolor: C.bg,
//           borderBottom: `1px solid ${C.border}`,
//           display: 'flex',
//           alignItems: 'center',
//           pr: 3,
//           gap: 2,
//         }}
//       >

//         {/* ── Offset spacer — matches sidebar width exactly ── */}
//         <Box sx={{
//           width: `${sidebarW}px`,
//           flexShrink: 0,
//           transition: 'width 0.25s cubic-bezier(0.4,0,0.2,1)',
//         }} />

//         {/* ── Search starts right after the sidebar ── */}
//         {role && <SmartSearch role={role} />}

//         {/* ── Spacer ── */}
//         <Box sx={{ flex: 1 }} />

//         {/* ── Right actions ── */}
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>

//           {/* Notifications */}
//        {/* Notifications */}
// <Tooltip title="Notifications" placement="bottom">
//   <IconButton
//     sx={{
//       width: 36, height: 36,
//       borderRadius: '8px',
//       color: C.textMuted,
//       position: 'relative',
//       '&:hover': { bgcolor: C.iconHover, color: C.text },
//       transition: 'all 0.15s',
//     }}
//   >
//     <NotificationBell userId={userlogin?.data?._id} />
//   </IconButton>
// </Tooltip>

//           {/* Avatar */}
//         {/* Avatar */}
// <Tooltip title="Account" placement="bottom">
//   <IconButton
//     onClick={(e) => setMenuAnchor(e.currentTarget)}
//     sx={{
//       width: 36, height: 36,
//       borderRadius: '8px',
//       border: '0.5px solid #EAECF0',
//       padding: '3px',
//       ml: '2px',
//       '&:hover': { bgcolor: C.iconHover, borderColor: '#D0D5DD' },
//       transition: 'all 0.15s',
//     }}
//   >
//     {profileImage ? (
//       <Avatar
//         src={profileImage}
//         sx={{ width: 28, height: 28, borderRadius: '6px', fontSize: '11px' }}
//       />
//     ) : (
//       <Avatar
//         sx={{
//           width: 28, height: 28,
//           borderRadius: '6px',        // ← مش دايري، مربع بحواف ناعمة
//           fontSize: '11px',
//           fontWeight: 500,
//           fontFamily: "'DM Sans', sans-serif",
//           bgcolor: C.accentSoft,
//           color: C.accent,
//           letterSpacing: '0.03em',
//         }}
//       >
//         {getInitials(userName)}
//       </Avatar>
//     )}
//   </IconButton>
// </Tooltip>
//         </Box>
//       </Box>

//       {/* ── Dropdown menu ── */}
//       <Menu
//         anchorEl={menuAnchor}
//         open={Boolean(menuAnchor)}
//         onClose={() => setMenuAnchor(null)}
//         transformOrigin={{ horizontal: 'right', vertical: 'top' }}
//         anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
//         slotProps={{
//           paper: {
//             elevation: 0,
//             sx: {
//               mt: '8px', minWidth: 260,
//               borderRadius: '12px',
//               border: `1px solid ${C.border}`,
//               boxShadow: '0 8px 32px rgba(16,24,40,0.10)',
//               overflow: 'visible',
//               '&::before': {
//                 content: '""', display: 'block', position: 'absolute',
//                 top: -6, right: 14, width: 11, height: 11,
//                 bgcolor: '#fff', border: `1px solid ${C.border}`,
//                 borderBottom: 'none', borderRight: 'none',
//                 transform: 'rotate(45deg)', zIndex: 0,
//               },
//             },
//           },
//         }}
//       >
//         {/* Profile header */}
//         <Box sx={{ px: 2, py: 1.5, display: 'flex', alignItems: 'center', gap: 1.5 }}>
//           {profileImage ? (
//             <Avatar src={profileImage} sx={{ width: 38, height: 38 }} />
//           ) : (
//             <Avatar sx={{
//               width: 38, height: 38, fontSize: '13px', fontWeight: 700,
//               fontFamily: "'DM Sans', sans-serif",
//               bgcolor: C.accentSoft, color: C.accent,
//             }}>
//               {getInitials(userName)}
//             </Avatar>
//           )}
//           <Box sx={{ overflow: 'hidden' }}>
//             <Typography sx={{
//               fontSize: '13.5px', fontWeight: 600, color: C.text,
//               fontFamily: "'DM Sans', sans-serif",
//               whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
//             }}>
//               {userName}
//             </Typography>
//             <Typography sx={{
//               fontSize: '12px', color: C.textMuted,
//               fontFamily: "'DM Sans', sans-serif",
//               whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
//             }}>
//               {userEmail || role}
//             </Typography>
//           </Box>
//         </Box>

//         <Divider sx={{ borderColor: C.border }} />

//         <DropdownItem
//           icon={<AccountCircleOutlinedIcon sx={{ fontSize: '17px' }} />}
//           label="My Account"
//           onClick={() => { setMenuAnchor(null); navigate('/MyAccount'); }}
//         />
//         {leadsRoute && (
//           <DropdownItem
//             icon={<ListAltIcon sx={{ fontSize: '17px' }} />}
//             label={role === 'Admin' ? 'All Leads' : 'My Leads'}
//             onClick={() => { setMenuAnchor(null); navigate(leadsRoute); }}
//           />
//         )}
//         <DropdownItem
//           icon={<PersonAddAltIcon sx={{ fontSize: '17px' }} />}
//           label="Create New Lead"
//           onClick={() => { setMenuAnchor(null); navigate('/addclient'); }}
//         />
//         {dataCenterRoute && role !== 'Accountant' && (
//           <DropdownItem
//             icon={<ListAltIcon sx={{ fontSize: '17px' }} />}
//             label="Data Center"
//             onClick={() => { setMenuAnchor(null); navigate(dataCenterRoute); }}
//           />
//         )}

//         <Divider sx={{ borderColor: C.border, my: '4px' }} />

//         <DropdownItem
//           icon={<LogoutIcon sx={{ fontSize: '17px' }} />}
//           label="Logout"
//           danger
//           onClick={() => { setMenuAnchor(null); logout(); }}
//         />

//         <Box sx={{ px: 2, py: 1, borderTop: `1px solid ${C.border}`, mt: '4px' }}>
//           <Typography sx={{
//             fontSize: '11px', color: C.textMuted,
//             fontFamily: "'DM Sans', sans-serif", textAlign: 'center',
//           }}>
//             © {new Date().getFullYear()} Realatix CRM
//           </Typography>
//         </Box>
//       </Menu>
//     </Box>
//   );
// };

































// after 20-5-2026
// Navbarheader — updated with SmartSearch (Enter-triggered panel) + NotificationBell
import React, { useEffect, useState } from 'react';
import {
  Box, Typography, IconButton, Avatar, Tooltip,
  Menu, MenuItem, Divider,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import PersonAddAltIcon          from '@mui/icons-material/PersonAddAlt';
import ListAltIcon               from '@mui/icons-material/ListAlt';
import LogoutIcon                from '@mui/icons-material/Logout';
import ChevronRightIcon          from '@mui/icons-material/ChevronRight';

import { Get_All_Sales_Action }        from '../Redux/Actions/SalesAction';
import { Getalldatauserlog_forsearch } from '../Redux/Actions/AuthAction';
import { Logoutsession_one_Device }    from '../Redux/Actions/Devices_Action';
import { Leftsidebare2 }               from '../Utility/Leftsidebare2';
import NotificationBell                from '../Pages/NotificationBell';   // ← موجود
import { SmartSearch }                 from '../Component/SmartSearch';    // ← الجديد

// ─── Tokens ───────────────────────────────────────────────────────────────────
const C = {
  bg:        '#FFFFFF',
  border:    '#EAECF0',
  text:      '#101828',
  textMuted: '#667085',
  accent:    '#1A3ECF',
  accentSoft:'#EEF1FD',
  iconHover: '#F2F4F7',
};

const NAVBAR_HEIGHT     = 64;
const SIDEBAR_EXPANDED  = 242;
const SIDEBAR_COLLAPSED = 64;

const LEADS_ROUTE = {
  Admin:         '/AllLeadsForAdmin',
  Sales:         '/AllLeadsForSales',
  'Team Leader': '/AllLeadsForTeamLeader',
  Manager:       '/LeadsForManagers',
  Accountant:    '/LeadsForAccountant',
  Marketer:      '/ALLLeadsForMarketer',
};

const DATA_CENTER_ROUTE = {
  Admin:         '/AllLeadsForAdminCRMDataQuickNumbers',
  Sales:         '/SalesQuickNumberCRMData',
  'Team Leader': '/TeamLeaderQuickNumbersCRMData',
};

const getInitials = (name = '') =>
  name.split(' ').filter(Boolean).map(w => w[0]).join('').toUpperCase().slice(0, 2) || 'U';

// ─── Dropdown item ────────────────────────────────────────────────────────────
const DropdownItem = ({ icon, label, onClick, danger }) => (
  <MenuItem onClick={onClick} sx={{
    px:2, py:'9px',
    display:'flex', alignItems:'center', gap:1.5,
    transition:'background 0.15s',
    '&:hover':{ bgcolor: danger ? '#FEF3F2' : '#F9FAFB' },
    '& .icon':{ color: danger ? '#D92D20' : '#667085', display:'flex', alignItems:'center' },
    '&:hover .icon':{ color: danger ? '#B42318' : '#344054' },
  }}>
    <Box className="icon">{icon}</Box>
    <Typography sx={{ flex:1, fontSize:'13.5px', fontWeight:400, fontFamily:"'DM Sans', sans-serif", color: danger ? '#D92D20' : '#344054' }}>
      {label}
    </Typography>
    <ChevronRightIcon sx={{ fontSize:'16px', color: danger ? '#D92D20' : '#D0D5DD' }} />
  </MenuItem>
);

// ─── Main ─────────────────────────────────────────────────────────────────────
export const Navbarheader = ({ setmode, mode }) => {
  const dispatch  = useDispatch();
  const locationn = useLocation();
  const navigate  = useNavigate();

  const [user,            setUser]            = useState(null);
  const [userlogin,       setUserlogin]       = useState(null);
  const [isMobile,        setIsMobile]        = useState(false);
  const [openDrawer,      setOpenDrawer]      = useState(false);
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [menuAnchor,      setMenuAnchor]      = useState(null);
  const [loadinglogout,   setLoadinglogout]   = useState(true);

  const savedDeviceId = localStorage.getItem('_deviceId');

  // ── Load user ─────────────────────────────────────────────────────────────
  useEffect(() => {
    const u = JSON.parse(localStorage.getItem('user') || 'null');
    if (u) { setUser(u); setUserlogin(u); }
  }, []);

  // ── Responsive ────────────────────────────────────────────────────────────
  useEffect(() => {
    const check = () => {
      const mobile = window.innerWidth < 600;
      setIsMobile(mobile);
      setOpenDrawer(!mobile);
    };
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  // ── Hide on login/root ────────────────────────────────────────────────────
  useEffect(() => {
    const path = locationn.pathname;
    setOpenDrawer(path !== '/' && path !== '/Login');
  }, [locationn.pathname]);

  // ── Preload data ──────────────────────────────────────────────────────────
  useEffect(() => {
    dispatch(Get_All_Sales_Action());
    dispatch(Getalldatauserlog_forsearch());
  }, []);

  // ── Logout ────────────────────────────────────────────────────────────────
  const logout = async () => {
    setLoadinglogout(true);
    await dispatch(Logoutsession_one_Device(user?.data?._id, savedDeviceId));
    setLoadinglogout(false);
  };

  useEffect(() => {
    if (!loadinglogout) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.setItem('isLoggedIn', 'false');
      window.location.href = '#/';
    }
  }, [loadinglogout]);

  // ── Derived ───────────────────────────────────────────────────────────────
  const role            = user?.data?.role;
  const userName        = user?.data?.name  || 'User';
  const userEmail       = user?.data?.email || '';
  const profileImage    = user?.data?.profileImg
    ? `/UsersImages/${user.data.profileImg.split('/UsersImages/').pop()}`
    : null;
  const leadsRoute      = LEADS_ROUTE[role];
  const dataCenterRoute = DATA_CENTER_ROUTE[role];
  const sidebarW        = sidebarExpanded ? SIDEBAR_EXPANDED : SIDEBAR_COLLAPSED;

  return (
    <Box sx={{ position:'relative' }}>

      {/* ── Sidebar ── */}
      <Box sx={{ position:'fixed', top:0, left:0, zIndex:1200, height:'100vh' }}>
        <Leftsidebare2
          openDrawer={openDrawer}
          isMobile={isMobile}
          toggleDrawer={() => setOpenDrawer(p => !p)}
          setOpenDrawer={setOpenDrawer}
          setmode={setmode}
          mode={mode}
          onExpandedChange={setSidebarExpanded}
        />
      </Box>

      {/* ── Navbar ── */}
      <Box
        id="navbarr"
        component="header"
        sx={{
          position:'fixed',
          top:0, left:0, right:0,
          zIndex:1100,
          height:`${NAVBAR_HEIGHT}px`,
          bgcolor:C.bg,
          borderBottom:`1px solid ${C.border}`,
          display:'flex',
          alignItems:'center',
          pr:3,
          gap:2,
        }}
      >
        {/* Sidebar width offset */}
        <Box sx={{
          width:`${sidebarW}px`,
          flexShrink:0,
          transition:'width 0.25s cubic-bezier(0.4,0,0.2,1)',
        }} />

        {/* ── SmartSearch
              Admin   → Enter يطلع الـ panel
              Others  → بيبعت لـ localStorage + window event بس
        ── */}
        {role && <SmartSearch role={role} />}

        {/* Spacer */}
        <Box sx={{ flex:1 }} />

        {/* ── Right actions ── */}
        <Box sx={{ display:'flex', alignItems:'center', gap:'2px' }}>

          {/* ── NotificationBell ── */}
          <NotificationBell userId={userlogin?.data?._id} />

          {/* ── Avatar / Account menu ── */}
          <Tooltip title="Account" placement="bottom">
            <IconButton
              onClick={(e) => setMenuAnchor(e.currentTarget)}
              sx={{
                width:36, height:36,
                borderRadius:'8px',
                border:'0.5px solid #EAECF0',
                padding:'3px',
                ml:'4px',
                '&:hover':{ bgcolor:C.iconHover, borderColor:'#D0D5DD' },
                transition:'all 0.15s',
              }}
            >
              {profileImage ? (
                <Avatar src={profileImage} sx={{ width:28, height:28, borderRadius:'6px', fontSize:'11px' }} />
              ) : (
                <Avatar sx={{
                  width:28, height:28, borderRadius:'6px',
                  fontSize:'11px', fontWeight:500,
                  fontFamily:"'DM Sans', sans-serif",
                  bgcolor:C.accentSoft, color:C.accent,
                  letterSpacing:'0.03em',
                }}>
                  {getInitials(userName)}
                </Avatar>
              )}
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      {/* ── Dropdown menu ── */}
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
        transformOrigin={{ horizontal:'right', vertical:'top' }}
        anchorOrigin={{ horizontal:'right', vertical:'bottom' }}
        slotProps={{
          paper:{
            elevation:0,
            sx:{
              mt:'8px', minWidth:260,
              borderRadius:'12px',
              border:`1px solid ${C.border}`,
              boxShadow:'0 8px 32px rgba(16,24,40,0.10)',
              overflow:'visible',
              '&::before':{
                content:'""', display:'block', position:'absolute',
                top:-6, right:14, width:11, height:11,
                bgcolor:'#fff', border:`1px solid ${C.border}`,
                borderBottom:'none', borderRight:'none',
                transform:'rotate(45deg)', zIndex:0,
              },
            },
          },
        }}
      >
        {/* Profile header */}
        <Box sx={{ px:2, py:1.5, display:'flex', alignItems:'center', gap:1.5 }}>
          {profileImage ? (
            <Avatar src={profileImage} sx={{ width:38, height:38 }} />
          ) : (
            <Avatar sx={{
              width:38, height:38, fontSize:'13px', fontWeight:700,
              fontFamily:"'DM Sans', sans-serif",
              bgcolor:C.accentSoft, color:C.accent,
            }}>
              {getInitials(userName)}
            </Avatar>
          )}
          <Box sx={{ overflow:'hidden' }}>
            <Typography sx={{ fontSize:'13.5px', fontWeight:600, color:C.text, fontFamily:"'DM Sans', sans-serif", whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
              {userName}
            </Typography>
            <Typography sx={{ fontSize:'12px', color:C.textMuted, fontFamily:"'DM Sans', sans-serif", whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
              {userEmail || role}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ borderColor:C.border }} />

        <DropdownItem
          icon={<AccountCircleOutlinedIcon sx={{ fontSize:'17px' }} />}
          label="My Account"
          onClick={() => { setMenuAnchor(null); navigate('/MyAccount'); }}
        />
        {leadsRoute && (
          <DropdownItem
            icon={<ListAltIcon sx={{ fontSize:'17px' }} />}
            label={role === 'Admin' ? 'All Leads' : 'My Leads'}
            onClick={() => { setMenuAnchor(null); navigate(leadsRoute); }}
          />
        )}
        <DropdownItem
          icon={<PersonAddAltIcon sx={{ fontSize:'17px' }} />}
          label="Create New Lead"
          onClick={() => { setMenuAnchor(null); navigate('/addclient'); }}
        />
        {dataCenterRoute && role !== 'Accountant' && (
          <DropdownItem
            icon={<ListAltIcon sx={{ fontSize:'17px' }} />}
            label="Data Center"
            onClick={() => { setMenuAnchor(null); navigate(dataCenterRoute); }}
          />
        )}

        <Divider sx={{ borderColor:C.border, my:'4px' }} />

        <DropdownItem
          icon={<LogoutIcon sx={{ fontSize:'17px' }} />}
          label="Logout"
          danger
          onClick={() => { setMenuAnchor(null); logout(); }}
        />

        <Box sx={{ px:2, py:1, borderTop:`1px solid ${C.border}`, mt:'4px' }}>
          <Typography sx={{ fontSize:'11px', color:C.textMuted, fontFamily:"'DM Sans', sans-serif", textAlign:'center' }}>
            © {new Date().getFullYear()} Realatix CRM
          </Typography>
        </Box>
      </Menu>
    </Box>
  );
};